import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import ExternalLink from 'app/src/elements/ExternalLink';

import { Text } from 'app/src/styles';
import colors from 'app/src/styles/colors';

const ADR_URL = 'https://autodealersresource.com/collections/temporary-tags';
const OTT_URL = 'https://shop.oklahomatemptag.com/';

const Container = styled(View)`
  margin-top: 120px;
  margin-left: 40px;
  margin-right: 30px;
  background-color: white;
  padding: 24px;
  filter: drop-shadow(0px 4px 30px rgba(0, 100, 0, 0.8));
`;

const OrderText = styled(Text)`
  font-weight: 600;
  font-size: 18px;
  text-align: center;
`;

const DirectText = styled(Text)`
  margin-top: 16px;
  font-weight: 600;
  font-size: 15px;
  text-align: center;
  color: ${colors.button};
`;

const OrderTags = () => {
  return (
    <Container>
      <ExternalLink url={ADR_URL}>
        <View>
          <OrderText>To order more Oklahoma</OrderText>
          <OrderText>10 Day Temporary Tags,</OrderText>
          <OrderText>click here to visit</OrderText>
          <OrderText>the ADR store.</OrderText>
        </View>
      </ExternalLink>

      <ExternalLink url={OTT_URL}>
        <View>
          <DirectText>Or order direct at</DirectText>
          <DirectText style={{ marginTop: 0 }}>
            shop.OklahomaTempTag.com
          </DirectText>
        </View>
      </ExternalLink>
    </Container>
  );
};

export default OrderTags;
